import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "format-datetime",
  templateUrl: "./format-datetime.component.html",
  styleUrls: ["./format-datetime.component.scss"],
})
export class FormatDatetimeComponent {
  @Input() parentForm!: FormGroup; // Ana form grubu (Örn: secondFormGroup)
  @Input() controlName!: string; // Form kontrolünün adı (Örn: 'startdate' veya 'enddate')
  @Input() label: string = "Tarih"; // Kutunun üstünde yazacak yazı
  @Input() required: boolean = false; // Zorunlu mu?
  @Input() disabled: boolean = false;
  // Tarih değiştiğinde ana komponenti haberdar etmek için Event Emitter
  @Output() dateChange = new EventEmitter<any>();

  ngOnInit() {
    // this.checkDisabledState();
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes["disabled"]) {
    //   this.checkDisabledState();
    // }
  }

  private checkDisabledState() {
    if (this.parentForm && this.controlName) {
      const control = this.parentForm.get(this.controlName);
      if (control) {
        if (this.disabled) {
          control.disable(); // Eğer true geçilirse form kontrolünü kapatır
        } else {
          control.enable(); // Geçilmezse veya false ise açar
        }
      }
    }
  }

  onDateChange(event: any) {
    this.dateChange.emit(event);
  }
}
